import { InstanceBatch } from "../InstanceBatch";
import { DynamicDrawUsage } from "three";
import { RenderOrder } from "../../RenderOrder";
import { PrimitiveMeshInstance } from "./PrimitiveMeshInstance";
import { ShadingMode } from "flavr-common";
import { getTruncatedConeMaterial, getTruncatedConeReducedMaterial, getTruncatedConeDepthMaterial } from "./MaterialsForTruncatedCones";
import { getPrimitiveMeshReducedMaterial, getPrimitiveMeshDepthMaterial } from "./MaterialsForPrimitiveMeshes";
import { PRIMITIVE_MESH_INSTANCE_SHADER } from "./PrimitiveMeshInstanceShader";
import { TruncatedConeInstance } from "./TruncatedConeInstance";
import { TRUNCATED_CONE_INSTANCE_SHADER } from "./TruncatedConeInstanceShader";
const INITIAL_BATCH_SIZE = 64;
export class GeometryInstanceBatch extends InstanceBatch {
    constructor(rootNode, geometry, defaultMaterial, reducedMaterial, attributes, renderOrder, instanceType, castShadow, receiveShadow, customDepthMaterial) {
        super(rootNode, geometry, defaultMaterial, attributes, renderOrder, instanceType, INITIAL_BATCH_SIZE, DynamicDrawUsage, castShadow, receiveShadow, customDepthMaterial);
        this.defaultMaterial = defaultMaterial;
        this.reducedMaterial = reducedMaterial;
    }
    setUseReducedMaterial(reduced) {
        const material = reduced ? this.reducedMaterial : this.defaultMaterial;
        this.setMaterial(material, reduced);
    }
}
export class PrimitiveMeshBatch extends GeometryInstanceBatch {
    constructor(rootNode, geometry, material, receiveshadow = false, castShadow = false, renderOrder = RenderOrder.OPAQUE_GEOMETRY) {
        super(rootNode, geometry, material, getPrimitiveMeshReducedMaterial(), PRIMITIVE_MESH_INSTANCE_SHADER.attributes, renderOrder, PrimitiveMeshInstance, castShadow, receiveshadow, receiveshadow ? getPrimitiveMeshDepthMaterial() : undefined);
    }
}
export class TruncatedConeBatch extends GeometryInstanceBatch {
    constructor(rootNode, geometry, material) {
        const shadow = material.shading === ShadingMode.PhongWithShadows;
        const renderOrder = material.shading === ShadingMode.TransparentGrid ? RenderOrder.TRANSPARENT_GEOMETRY : RenderOrder.OPAQUE_GEOMETRY;
        super(rootNode, geometry.clone(), getTruncatedConeMaterial(material), getTruncatedConeReducedMaterial(), TRUNCATED_CONE_INSTANCE_SHADER.attributes, renderOrder, TruncatedConeInstance, material.castShadow, shadow, shadow ? getTruncatedConeDepthMaterial() : undefined);
    }
}
